import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface PowerSteeringFluidProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function PowerSteeringFluid(props: PowerSteeringFluidProps) {
  return (
    <svg
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 74, left: 175}}
      onClick={props.onClick}
    >
      <path
        d="M7 1H23C29 1 29 7 29 7V27C29 33 23 33 23 33H7C1 33 1 27 1 27L1 7C1 7 1 1 7 1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M7 1.00002H23C29 1.00002 29 7.00002 29 7.00002V27C29 33 23 33 23 33H7C1 33 1 27 1 27L1 7.00002C1 7.00002 1 1.00002 7 1.00002Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 15L19 21.9282L11 21.9282L6.99997 15L11 8.07181L19 8.07181L23 15Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="15"
        cy="15"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
